import { getApiBase } from "_helpers";


/**
 * Sends an email with a payment receipt.
 *
 * @param {string} email - The email address to send the receipt to.
 * @param {string} receipt - The payment receipt content.
 * @param {function} cb - The callback function to be called with the response data.
 */

const emailPaymentReceipt = (email, receipt, cb) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, receipt })
    };

    fetch(`${getApiBase()}/public/email-payment-receipt`, requestOptions)
        .then(response => response.json())
        .then(data => {
            cb(data);
        });
}


const emailRecoveryAgent = (payload) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(`${getApiBase()}/public/email-recovery-agent`, requestOptions)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Unable to email recovery agent (${response.status})`);
            }
            return response;
        });
}

const logPayment = (payload) => {
    const body = JSON.stringify(payload);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: new Blob([body]).size <= 65536
    };

    return fetch(`${getApiBase()}/public/log-payment`, requestOptions)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Unable to record payment (${response.status})`);
            }
            return response;
        });
}

const contactRAForAssistance = (payload) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    fetch(`${getApiBase()}/public/recovery-agent-assist`, requestOptions);
}



export const publicService = {
    emailPaymentReceipt,
    emailRecoveryAgent,
    logPayment,
    contactRAForAssistance
};
